__turbopack_context__.v({
  "accordionControl": "LearningFormat-module__ZwObFG__accordionControl",
  "accordionControlInner": "LearningFormat-module__ZwObFG__accordionControlInner",
  "accordionItem": "LearningFormat-module__ZwObFG__accordionItem",
  "accordionLabel": "LearningFormat-module__ZwObFG__accordionLabel",
  "accordionRoot": "LearningFormat-module__ZwObFG__accordionRoot",
  "accordionRootHalf": "LearningFormat-module__ZwObFG__accordionRootHalf",
  "campusPriceButton": "LearningFormat-module__ZwObFG__campusPriceButton",
  "detailsCollapse": "LearningFormat-module__ZwObFG__detailsCollapse",
  "formatDescription": "LearningFormat-module__ZwObFG__formatDescription",
  "formatDetailSection": "LearningFormat-module__ZwObFG__formatDetailSection",
  "formatFactDescription": "LearningFormat-module__ZwObFG__formatFactDescription",
  "formatHeader": "LearningFormat-module__ZwObFG__formatHeader",
  "formatHeaderTop": "LearningFormat-module__ZwObFG__formatHeaderTop",
  "formatIcon": "LearningFormat-module__ZwObFG__formatIcon",
  "formatShortDescription": "LearningFormat-module__ZwObFG__formatShortDescription",
  "formatTitle": "LearningFormat-module__ZwObFG__formatTitle",
  "formatWhyChoose": "LearningFormat-module__ZwObFG__formatWhyChoose",
  "mobileAccordionControl": "LearningFormat-module__ZwObFG__mobileAccordionControl",
  "mobileAccordionItem": "LearningFormat-module__ZwObFG__mobileAccordionItem",
  "mobileAccordionRoot": "LearningFormat-module__ZwObFG__mobileAccordionRoot",
  "mobileBody": "LearningFormat-module__ZwObFG__mobileBody",
  "mobileCardFrame": "LearningFormat-module__ZwObFG__mobileCardFrame",
  "mobileOption": "LearningFormat-module__ZwObFG__mobileOption",
  "mobileOptionCard": "LearningFormat-module__ZwObFG__mobileOptionCard",
  "modalityFootnote": "LearningFormat-module__ZwObFG__modalityFootnote",
  "pricePrimary": "LearningFormat-module__ZwObFG__pricePrimary",
  "priceSecondary": "LearningFormat-module__ZwObFG__priceSecondary",
  "priceStack": "LearningFormat-module__ZwObFG__priceStack",
  "priceTertiary": "LearningFormat-module__ZwObFG__priceTertiary",
  "priceTertiaryUnavailable": "LearningFormat-module__ZwObFG__priceTertiaryUnavailable",
  "priceUnavailable": "LearningFormat-module__ZwObFG__priceUnavailable",
  "priceUnavailableIcon": "LearningFormat-module__ZwObFG__priceUnavailableIcon",
  "stickyHeader": "LearningFormat-module__ZwObFG__stickyHeader",
  "stickySentinel": "LearningFormat-module__ZwObFG__stickySentinel",
  "whyChoosePhone": "LearningFormat-module__ZwObFG__whyChoosePhone",
  "whyChooseTablet": "LearningFormat-module__ZwObFG__whyChooseTablet",
});
